import React from 'react'
import { Button } from 'reactstrap'

const BackButton = ({onClick , title='Back' , type}) => {
  return (
    <Button type={type} className="mt-4 " onClick={onClick} style={{backgroundColor : 'transparent' , borderColor : "#E5E7EB" , color : "black" }}>
        {title}
    </Button>
  )
}

export default BackButton